import styles from "./product-page-calendar.module.less";
import { Calendar, createDate } from "@parksandresorts/core";

const ProductPageCalendar = (props) => {
  const today = createDate();
  const { selectedDate, productCalendar, onClickDate, onChangeMonth, currentDisplayedMonth } = props;

  return (
    <div className={styles.wrapper}>
      {props.showServiceError && props.serviceErrorText && (
        <div className={styles.serviceErrorWrapper}>
          <div className={styles.imageWrapper}>
            <img src="/images/emoji/sad_crying.svg" alt="" />
          </div>
          <h3 className={styles.serviceErrorText}>{props.serviceErrorText}</h3>
        </div>
      )}
      <Calendar
        calendarData={productCalendar}
        changeDate={onClickDate}
        changedMonth={onChangeMonth}
        selectedDates={selectedDate}
        currentDisplayedMonth={currentDisplayedMonth ?? today}
        disableEmptyDates
        startDate={today}
      />
    </div>
  );
};

export default ProductPageCalendar;
